import { formatDate } from './formatDate';

export function timeHHmmFormat(value) {
  return formatDate(value, 'HH:mm');
}
